<section class="activity" *ngIf="viewModel$ | async as viewModel">
  <div class="activity-header">
    <div class="activity-title">
      <h2>
        <i class="pi pi-bolt p-mr-1"></i> <span class="p-mr-1">Activity</span>
      </h2>
      <p-badge [value]="viewModel.totalComments" />
    </div>
    <ng-container *ngIf="viewModel.heartbeatEnabled">
      <ng-container *ngIf="viewModel.aiIsDisabled; else heartbeatTpl">
        <span class="ai-disabled-label p-mr-2">
          <i class="pi pi-ban" style="font-size: 0.75rem;"></i>
          <span *ngIf="viewModel.heartbeatInfo.aiDisabled === -1">AI Disabled: Permanently</span>
          <span *ngIf="viewModel.heartbeatInfo.aiDisabled !== -1">AI Disabled: {{ viewModel.heartbeatInfo.aiDisabled * 1000 | date:'shortTime' }}</span>
        </span>
        <button pButton type="button" label="Resume AI" icon="pi pi-check"
          class="p-button-sm p-button-success p-mr-2"
          (click)="resumeAI(viewModel.heartbeatInfo.jobId)"></button>
      </ng-container>
      <ng-template #heartbeatTpl>
        <button class="heartbeat-btn" type="button"
          [pTooltip]="heartbeatLoading ? 'Heartbeat is running...' : (viewModel.heartbeatInfo.heartbeatMessage || '')" aria-label="AI settings menu"
          [tooltipStyleClass]="'heartbeat-tooltip'" tooltipPosition="left"
          [disabled]="heartbeatLoading"
          (click)="heartbeatMenu.toggle($event)">
          <i class="pi" [ngClass]="heartbeatLoading ? 'pi-spin pi-spinner' : 'pi-android'"></i>
        </button>
      </ng-template>
    </ng-container>
  </div>
  <p-menu #heartbeatMenu [popup]="true" [model]="viewModel.heartbeatMenuItems" appendTo="body"></p-menu>

  <main>
    <app-job-add-comment></app-job-add-comment>

      <!-- Custom timeline structure using divs and ngFor -->
      <div class="timeline">
          <div
              *ngFor="let comment of viewModel.comments; trackBy: identifyComment; let last = last"
              class="timeline-event"
          >
              <!-- This div represents the vertical line and the marker -->
              <div class="timeline-event-separator">
                  <span
                      class="timeline-event-marker"
                      [pTooltip]="'Mode: ' + comment?.mode?.name || 'Comment'"
                  >
                      <!-- Render icon if available, otherwise a default bullet point -->
                      <i [class]="comment?.mode?.icon || 'pi pi-circle-fill'"></i>
                  </span>
                  <!-- The connector line, not rendered for the last item -->
                  <div
                      class="timeline-event-connector"
                      *ngIf="!last"
                  ></div>
              </div>

              <!-- This div holds the comment content -->
              <div class="timeline-event-content">
                  <app-job-comment
                      class="comment"
                      [class.system]="comment?.mode?.system || !comment?.author"
                      [class.topLevel]="true"
                      [comment]="comment"
                  >
                  </app-job-comment>
              </div>
          </div>
      </div>
  </main>
</section>
